export default {
  _: 'Account external links',
  sourceSystem: 'Source system',
  status: 'Status',
  lastUpdate: 'Last update',
  referenceId: 'Reference ID',
  delete: 'Delete',
  deleteWarning:
    'Please confirm the deletion of the link. You will not be able to cancel the deletion.',
  deleteConfirmationTitle: 'Delete account link',
  deleteSuccessMessage: 'Account link is deleted successfully!',
  editDrawerTitle: 'Edit account link',
  createDrawerTitle: 'Add account link',
  empty: 'There are no account external links yet.',
  linkAction: 'View details',
  encodedKey: 'Encoded key',
  id: 'ID',
  system: 'System',
  additionalData: 'Additional data',
  invalidJson: 'Invalid JSON',
  INITIAL: 'Initial',
  ACTIVE: 'Active',
  PENDING: 'Pending',
  REJECTED: 'Rejected',
  CLOSED: 'Closed',
  linkType: 'Link type',
  identificationDetails: 'Identification details',
  lastError: 'Last error',
};
